module.exports = __webpack_public_path__ + "img/export-icon.e973d992.png";